// Small set of formatters used across the drafts table and detail page.
// Locale-fixed to en-US for now; an admin in Romania reading "$0.05" and
// "2 hours ago" is fine — the audience is the founder, not end-users.

export function formatRelativeTime(iso: string): string {
  const then = new Date(iso).getTime();
  if (!Number.isFinite(then)) return iso;
  const diffMs = Date.now() - then;
  const seconds = Math.round(diffMs / 1000);
  if (seconds < 60) return 'just now';
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours} h ago`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${days} d ago`;
  // Beyond a month, ISO date is more useful than "N months ago".
  return new Date(iso).toISOString().slice(0, 10);
}

export function formatUsd(amount: number): string {
  // 4 decimal places at the small end (LLM calls are often $0.0003)
  // but trim trailing zeros for the common $0.01-$0.50 range.
  if (amount < 0.01) return `$${amount.toFixed(4)}`;
  if (amount < 1) return `$${amount.toFixed(3)}`;
  return `$${amount.toFixed(2)}`;
}

export function formatDurationMs(ms: number): string {
  if (ms < 1000) return `${ms} ms`;
  const sec = ms / 1000;
  if (sec < 60) return `${sec.toFixed(1)} s`;
  const min = sec / 60;
  return `${min.toFixed(1)} min`;
}

const DOC_KIND_LABELS: Record<string, string> = {
  visual_menu: 'Visual menu',
  nutrition_doc: 'Nutrition doc',
  allergen_chart: 'Allergen chart',
  beverage_list: 'Beverage list',
};
export function formatDocKind(kind: string): string {
  return DOC_KIND_LABELS[kind] ?? kind;
}

const STATUS_LABELS: Record<string, string> = {
  draft: 'Draft',
  approved: 'Approved',
  rejected: 'Rejected',
  failed: 'Failed',
};
export function formatStatus(status: string): string {
  return STATUS_LABELS[status] ?? status;
}
